import React from 'react';
import FeedBackLayout from '@/components/feedback-layout';

export default function MyCreate(props) {
  return (
    <div>
      {props.children}
      <FeedBackLayout showConSult={true} showSurvey={true} />
    </div>
  );
}
